module.exports = __webpack_public_path__ + "img/phan-quyen-icon.ceda7bec.svg";